module.exports = __webpack_public_path__ + "static/hm-1fc58f52aa9de036b9128b7cc42c459c.svg";